import { Dispatch } from "redux";

import { addNotification } from "../store/actions/genericActions";
import { notifications } from "../notifications";
import { roundFileSizeInMB } from "./roundFileSizeInMB";
import { isAcceptedFile } from "./fileTypes";
import { FileAttachmentConfig } from "../definitions";

/*
 * Validates all provided files and shows an error notification for every invalid file.
 * Returns all valid files.
 */

/*
 * Limite de mídias por mensagem na Twilio. O teto vive AQUI, no momento de anexar, e não no envio:
 * a recusa deles chegava como erro técnico depois da mensagem montada, e o cliente não tinha o que
 * fazer com aquilo (alerta de produção "Too many media attachments (51 > 25)", 05/08/2026).
 *
 * A pilha cresce porque, quando o envio falha, os anexos são PRESERVADOS de propósito
 * (MessageInput: `detachFiles` só no sucesso — perder o que o cliente anexou já foi incidente).
 * Essa preservação está certa; o que faltava era o teto.
 */
export const MAX_ANEXOS_POR_MENSAGEM = 25;
export const validateFiles = (
    files: File[],
    dispatch: Dispatch,
    attachedFiles?: File[],
    fileAttachmentConfig?: FileAttachmentConfig
): File[] => {
    return files.reduce<File[]>((validFilesAcc, file) => {
        // Conta os que JÁ estão anexados + os aprovados nesta rodada: é entre uma tentativa e outra
        // que a pilha cresce, então olhar só os novos não seguraria nada.
        if ((attachedFiles?.length ?? 0) + validFilesAcc.length >= MAX_ANEXOS_POR_MENSAGEM) {
            dispatch(
                addNotification(
                    notifications.fileAttachmentTooManyNotification({ maxFiles: MAX_ANEXOS_POR_MENSAGEM })
                )
            );
        } else if (
            attachedFiles &&
            attachedFiles.some(
                (attachedFile) =>
                    file.name === attachedFile.name &&
                    file.type === attachedFile.type &&
                    file.size === attachedFile.size
            )
        ) {
            dispatch(
                addNotification(
                    notifications.fileAttachmentAlreadyAttachedNotification({
                        fileName: file.name
                    })
                )
            );
        } else if (fileAttachmentConfig?.maxFileSize && file.size > fileAttachmentConfig.maxFileSize) {
            dispatch(
                addNotification(
                    notifications.fileAttachmentInvalidSizeNotification({
                        fileName: file.name,
                        maxFileSize: `${roundFileSizeInMB(fileAttachmentConfig?.maxFileSize)}MB`
                    })
                )
            );
        } else if (!isAcceptedFile(file, fileAttachmentConfig?.acceptedExtensions)) {
            dispatch(
                addNotification(
                    notifications.fileAttachmentInvalidTypeNotification({
                        fileName: file.name
                    })
                )
            );
        } else {
            validFilesAcc.push(file);
        }

        return validFilesAcc;
    }, []);
};
